<template>
  <div class="layout-list" ref="layout-list">
    <!-- <div class="tipDialogBtn" @click="fun_GetUnpackDialog" v-if="dialogTipList && dialogTipList.length > 0"><i class="el-icon-info"></i>
      <div class="text">
        温馨提示
      </div>
    </div>
    <div class="dialogTip" :class="dialog ? '' : 'dialogHidden'">
      <div class="dialogHeader">
        <div class="t">温馨提示</div>
        <div class="rIcon"><i class="el-icon-close" @click="fun_GetOffDialog"></i></div>
      </div>
      <div class="tipCentent">
        <div class="title"><i class="el-icon-warning"></i>系统操作提醒</div>
        <div class="ul">
          <div class="li" v-for="(item, index) in dialogTipList" :key="index">
            <slot :name="item.slotName" v-if="item.type === 'slot'" />
            <div class="tit" v-else-if="item.type === 'AdobeReader'" v-html="fun_GetTip(index)"></div>
            <div class="tit" v-else>{{ item.text }}</div>
          </div>
        </div>
      </div>
      <div class="dialogBtn">
        <el-button class="comBtn" @click="fun_GetOffDialog">我知道了</el-button>
      </div>
    </div> -->
    <el-form
      :model="form"
      ref="form"
      :label-width="labelWidth"
      :inline="true"
      v-if="formSearchList && formSearchList.length > 0"
    >
      <el-row>
        <el-col
          :class="isUnfold || formSearchList.length <= 3 || !spread ? '' : 'up'"
          :span="formSearchList.length <= 3 || !spread ? 24 : 19"
        >
          <el-form-item
            ref="formItem"
            v-for="(item, index) in formSearchList"
            :class="item.required ? '' : 'textLabel'"
            :key="index"
            :label="item.label"
            :prop="item.value"
            :error="errRules ? errRules[item.value] : ''"
            :rules="item.rule ? item.rule : {}"
            style="text-align: left"
          >
            <!-- solt -->
            <template v-if="item.type === 'slot'">
              <slot :name="item.slotName" />
            </template>
            <!-- 输入框 -->
            <el-input
              v-model="form[item.value]"
              v-if="item.type === 'input'"
              :disabled="item.disabled"
              :clearable="item.clearable"
              :placeholder="`${item.placeholder ? item.placeholder : ''}`"
            ></el-input>
            <!-- 密码输入框 -->
            <el-input
              v-model="form[item.value]"
              v-if="item.type === 'password'"
              type="password"
              :disabled="item.disabled"
              :clearable="item.clearable"
              :placeholder="`${item.placeholder ? item.placeholder : ''}`"
            ></el-input>
            <span v-if="item.inputSpan" style="margin-left: 8px">{{
              item.inputSpan
            }}</span>
            <!-- 下拉框 -->
            <Co-select
              :codeSting="form[item.value]"
              :field="item.value"
              :queryParams="item.queryParams ? item.queryParams : ''"
              :clearable="item.clearable ? item.clearable : true"
              :disabled="item.disabled"
              :optionData="item.optionData"
              :placeholder="`${item.placeholder ? item.placeholder : ''}`"
              :multipleValue="item.multipleValue ? item.multipleValue : false"
              v-if="item.type === 'select'"
              @change="fun_SelectChange"
              @clear="fun_Clear"
            />
            <!-- 树形下拉框 -->
            <Co-cascader
              ref="cascader"
              :codeSting="form[item.value]"
              :queryParams="item.queryParams ? item.queryParams : ''"
              :url="`${item.url ? item.url : ''}`"
              :clearable="item.clearable"
              :disabled="item.disabled"
              :filterable="item.filterable"
              :optionData="item.optionData"
              :propsData="item.propsData"
              :showAllLevels="item.showAllLevels"
              v-if="item.type === 'cascader'"
              @change="fun_SelectChange($event, item.value)"
            />
            <!-- 日期选择框 -->
            <el-date-picker
              v-if="item.type === 'date'"
              v-model="form[item.value]"
              :type="item.dateType"
              :picker-options="item.TimePickerOptions"
              :clearable="item.clearable"
              :disabled="item.disabled"
              :range-separator="`${item.separator ? item.separator : ''}`"
              :start-placeholder="`${item.dateType ? '开始日期' : ''}`"
              :end-placeholder="`${item.dateType ? '结束日期' : ''}`"
              :placeholder="`${item.placeholder ? item.placeholder : ''}`"
              :value-format="item.valueFormat"
            />
          </el-form-item>
          <!-- 查询 -->
          <el-form-item v-if="formSearchList.length <= 3 || !spread">
            <el-button
              class="comBtn"
              type="primary"
              icon="el-icon-search"
              @click="fun_Search"
              >查询</el-button
            >
          </el-form-item>
          <el-form-item
            v-if="resetBtn && (formSearchList.length <= 3 || !spread)"
            class="resetBtn"
          >
            <el-button
              class="resetBtn"
              icon="el-icon-refresh-right"
              @click="fun_Reset"
              v-if="resetBtn"
              >重置</el-button
            >
          </el-form-item>
          <el-form-item v-if="btnSlotName">
            <slot :name="btnSlotName" v-if="btnSlotName" />
          </el-form-item>
          <el-form-item
            class="searcBtn"
            v-if="searchList && searchList.length > 0"
          >
            <el-button
              v-for="(e, i) of searchList"
              :class="e.class ? e.class : ''"
              :key="i"
              :type="e.type"
              :icon="'el-icon-' + e.icon"
              :disabled="e.disabled"
              @click="fun_SearcClick(e.name)"
              >{{ e.name }}</el-button
            >
          </el-form-item>
        </el-col>
        <el-col
          v-if="formSearchList.length > 3 && spread"
          class="unfold"
          :span="formSearchList.length > 3 ? 5 : 0"
        >
          <el-form-item>
            <el-button
              class="comBtn"
              type="primary"
              icon="el-icon-search"
              @click="fun_Search"
              >查询</el-button
            >
          </el-form-item>
          <el-form-item v-if="resetBtn" class="resetBtn">
            <el-button
              class="resetBtn"
              icon="el-icon-refresh-right"
              @click="fun_Reset"
              v-if="resetBtn"
              >重置</el-button
            >
            <slot :name="btnSlotName" v-if="btnSlotName" />
          </el-form-item>
          <el-form-item class="upBtn">
            <div class="icon" @click="isUnfold = !isUnfold">
              {{ isUnfold ? "收起" : "展开"
              }}<i
                :class="isUnfold ? 'el-icon-arrow-up' : 'el-icon-arrow-down'"
              ></i>
            </div>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <div class="tips" v-if="tipList && tipList.length > 0">
      <p class="icon"><i class="el-icon-info"></i>温馨提示：</p>
      <div class="text" v-for="(t, i) in tipList" :key="i">
        <slot :name="t.slotName" v-if="t.type === 'slot'" />
        <div
          class="tit"
          v-else-if="t.type === 'AdobeReader'"
          v-html="fun_GetTip(index)"
        ></div>
        <div class="tit" v-else>{{ t.text }}</div>
      </div>
    </div>
    <div class="table-header" v-if="btnList && btnList.length > 0">
      <div v-for="(e, i) of btnList" :key="i" class="btnList">
        <!-- solt -->
        <template v-if="e.type === 'slot'">
          <slot :name="e.slotName" />
        </template>
        <el-button
          v-if="e.name"
          :class="e.class ? e.class : ''"
          :type="e.type"
          :icon="'el-icon-' + e.icon"
          :disabled="e.disabled"
          @click="fun_click(e.name)"
          >{{ e.name }}</el-button
        >
      </div>
      <el-tooltip popper-class="listPoperTip" effect="light" placement="bottom">
        <div slot="content" class="content">
          <div class="text" v-for="(item, index) in dialogTipList" :key="index">
            <slot :name="item.slotName" v-if="item.type === 'slot'" />
            <div
              class="tit"
              v-else-if="item.type === 'AdobeReader'"
              v-html="fun_GetTip(index)"
            ></div>
            <div class="tit" v-else>{{ item.text }}</div>
          </div>
        </div>
        <div
          class="poperTipBtn"
          v-if="dialogTipList && dialogTipList.length > 0"
        >
          <i class="el-icon-info"></i>温馨提示
        </div>
      </el-tooltip>
      <span style="color: red; padding-left: 15px" v-if="title">{{
        title
      }}</span>
      <span class="totalScore" v-if="totalScore">总分：{{ totalScore }}</span>
    </div>
    <p class="opTips" v-if="opTips && opTips.length > 0">
      <span class="el-icon-info">温馨提示：</span>
      <span v-for="(t, i) in opTips" :key="i">{{ t }}</span>
    </p>
    <p class="tipDol" v-if="tipDol">
      <slot :name="tipDol" />
    </p>
    <el-table
      v-if="tableColumns && tableColumns.length > 0"
      :data="tableData"
      ref="multipleTable"
      :border="border"
      fit
      v-loading="loading"
      element-loading-text="加载中..."
      element-loading-spinner="el-icon-loading"
      element-loading-background="rgba(0, 0, 0, 0.6)"
      style="width: 100%"
      :header-cell-style="headerStyle"
      :cell-style="{
        'text-align':'center'
      }"
      :show-header="showHeader"
      @selection-change="fun_HandleSelectionChange"
      row-key="id"
      :default-expand-all="defaultExpandAll"
      lazy
      :span-method="spanMethod"
      :load="load"
      :tree-props="treeProps"
      @sort-change="fun_ChangeTableSort"
      :row-class-name="tableRowClassName"
      @row-click="fun_RowClick"
      @cell-click="fun_CellClick"
      id="qwesd"
    >
      <el-table-column
        fixed="left"
        type="index"
        class-name="columnIndex"
        align="center"
        :width="indexWidth ? indexWidth : '60'"
        :label="columnLabel ? columnLabel : ''"
        v-if="index"
      ></el-table-column>
      <el-table-column
        fixed="left"
        type="selection"
        align="center"
        width="50"
        v-if="selection"
        :selectable="fun_SelectableCheck"
      ></el-table-column>
      <el-table-column
        v-for="(column, index) in tableColumns"
        :align="column.align ? column.align : 'left'"
        :prop="column.prop"
        :key="index"
        :label="column.label"
        :width="column.width"
        :min-width="column.minWidth"
        :show-overflow-tooltip="!column.showTool ? true : false"
        :sortable="column.sorting ? column.sorting : false"
        :fixed="column.fixed ? column.fixed : false"
        :class-name="column.className ? column.className : ''"
      >
        <template v-if="column.slot" slot="header">
          <p class="headerLabel">
            {{ column.label }}<span>{{ column.hint }}</span>
          </p>
        </template>
        <template slot-scope="scope">
          <span class="round" v-if="column.round"></span>
          <!-- 点击查看 -->
          <span
            class="lookSpan"
            :style="{ color: column.textColor ? column.textColor : '#0E70B5' }"
            style="cursor: pointer"
            @click="fun_LookDetails(scope.row)"
            v-if="column.isShow"
            ><span>{{ scope.row[column.prop] }}</span>
          </span>
          <!-- 状态 -->
          <span
            v-else-if="column.state"
            :style="{
              color:
                scope.row[column.prop] === column.state[0]
                  ? 'green'
                  : scope.row[column.prop] === column.state[1]
                  ? 'gray'
                  : scope.row[column.prop] === column.state[2]
                  ? 'red'
                  : 'black'
            }"
            >{{ scope.row[column.prop] }}</span
          >
          <!-- 时间展示 -->
          <span v-else-if="column.insertDate && scope.row[column.prop]">
            {{ scope.row[column.prop] | formatDate }}
          </span>
          <!-- 普通字段 -->
          <span v-else>
            {{ scope.row[column.prop] }}
          </span>
          <!-- 具名插槽传递参数 -->
          <slot
            :name="column.slotName"
            v-if="column.slotName"
            :data="scope.row"
          ></slot>
        </template>
      </el-table-column>
    </el-table>
    <Co-tooltip
      :tableCellMouse="tableCellMouse"
      :isF="isF"
      :num="num"
      v-if="cellShow"
    ></Co-tooltip>
    <el-pagination
      v-if="reqPageData.current"
      class="layout-pagein"
      @size-change="fun_HandleSizeChange"
      @current-change="fun_HandleCurrentChange"
      :current-page="reqPageData.current"
      :page-sizes="
        reqPageData.pageSizes ? reqPageData.pageSizes : [10, 20, 30, 50, 100]
      "
      :page-size="reqPageData.size"
      layout="total, sizes, prev, pager, next, jumper"
      :total="total"
      :key="reqPageData.current"
    >
    </el-pagination>
  </div>
</template>

<script>
// 引入时间格式转换方法
import { formatDate } from "@/utils/validate.js";
import { fun_GetAction } from "@/api";
export default {
  // 初始化
  data() {
    return {
      count: 0, // 根据数值清空勾选
      fileUrl: null, // 文件地址
      isUnfold: false, // 展开收起
      dialog: false // 提示弹窗
    };
  },
  // 过滤属性
  filters: {
    formatDate(time) {
      let date = new Date(time);
      // 返回时间格式
      return formatDate(date, "yyyy-MM-dd  hh:mm:ss");
    }
  },
  // 接收来自父组件的数据
  props: {
    // 列表头部样式
    headerStyle: {
      type: Object,
      default: () => {
        return { background: "#f5f5f5", textAlign: 'center' };
      }
    },
    // 是否展开收起
    spread: {
      type: Boolean,
      default: true
    },
    // 是否显示表头
    showHeader: {
      type: Boolean,
      default: true
    },
    // 是否需要边框
    border: {
      type: Boolean,
      default: true
    },
    // 自定义验证规则
    errRules: {
      type: Object
    },
    // 温馨提示
    tipList: {
      type: Array,
      default: () => {
        return [];
      }
    },
    // 操作按钮下面温馨提示
    opTips: {
      type: Array,
      default: () => {
        return [];
      }
    },
    // 弹窗温馨提示
    dialogTipList: {
      type: Array,
      default: () => {
        return [];
      }
    },
    // 操作按钮下面点击下载
    tipDol: {
      type: String,
      default: null
    },
    // tooltip组件dom元素
    num: {
      type: Number,
      default: 0
    },
    // 是否是评审项制作详情tabs嵌套页面
    isF: {
      type: Boolean,
      default: false
    },
    // tooltip组件参数对象
    tableCellMouse: {
      type: Object,
      default: () => {
        return {};
      }
    },
    // tooltip组件显隐
    cellShow: {
      type: Boolean,
      default: false
    },
    // 查询表单label宽度
    labelWidth: {
      type: String,
      default: "100px"
    },
    // 查询表单配置
    formSearchList: {
      type: Array,
      default: () => {
        return [];
      }
    },
    // 查询表单对象
    form: {
      type: Object,
      default: () => {
        return {};
      }
    },
    // 表格数据
    tableData: {
      type: Array,
      default: () => {
        return [];
      }
    },
    // 表格列数据
    tableColumns: {
      type: Array,
      required: false,
      default: () => {
        return [];
      }
    },
    // 表格嵌套tree
    treeProps: {
      type: Object,
      default: () => {}
    },
    // 相关字段
    propsData: {
      type: Object
    },
    // 序号宽度
    indexWidth: {
      type: String,
      default: "60"
    },
    // 列表序号改名
    columnLabel: {
      type: String,
      default: null
    },
    // 是否使用table的查看详情
    isShow: {
      type: Boolean,
      default: false,
      required: false
    },
    // loading状态
    loading: {
      type: Boolean,
      required: false
    },
    // 勾选方法
    fun_HandleSelectionChange: {
      type: Function,
      required: false,
      default: () => {}
    },
    // 合并方法
    spanMethod: {
      type: Function,
      required: false,
      default: () => {}
    },
    // 勾选方法
    fun_SelectableCheck: {
      type: Function,
      required: false,
      default: () => {
        return true;
      }
    },
    // 是否默认展开所有行，当 Table 包含展开行存在或者为树形表格时有效
    defaultExpandAll: {
      type: Boolean,
      default: true
    },
    // 把每一行的索引放进row
    tableRowClassName: {
      type: Function,
      required: false,
      default: () => {}
    },
    // 点击某一行执行
    fun_RowClick: {
      type: Function,
      required: false,
      default: () => {}
    },
    // 点击单元格执行
    fun_CellClick: {
      type: Function,
      required: false,
      default: () => {}
    },
    // 当表格的排序条件发生变化时执行
    fun_ChangeTableSort: {
      type: Function,
      required: false,
      default: () => {}
    },
    // 加载子节点数据的函数
    load: {
      type: Function,
      required: false,
      default: () => {}
    },
    // 按钮
    btnList: {
      type: Array,
      default: () => {
        return [];
      }
    },
    // 查询傍边按钮
    searchList: {
      type: Array,
      default: () => {
        return [];
      }
    },
    // 是否显示列表勾选
    selection: {
      type: Boolean,
      default: true
    },
    // 是否序号
    index: {
      type: Boolean,
      default: true
    },
    // 右下角button插槽
    btnSlotName: {
      type: String,
      default: null
    },
    // 重置按钮
    resetBtn: {
      type: Boolean,
      default: true
    },
    // 查询按钮
    searchBtn: {
      type: Boolean,
      default: true
    },
    // 是否显示分页
    pagination: {
      type: Boolean,
      default: true
    },
    // 表格插槽
    slotName: {
      default: null
    },
    // 分页器自定义校验对象
    reqPageData: {
      type: Object, // 类型
      // 默认值
      default: () => {
        return {};
      }
    },
    // 分页总条数
    total: {
      type: Number,
      default: 0
    },
    // 表头显示总分
    totalScore: {
      type: Number,
      default: null
    },
    // 表头显示总分
    title: {
      type: String,
      default: null
    }
  },
  // 监听事件
  watch: {
    // 根据数值清空勾选
    count(newVal) {
      // 如果值大于0，则清空勾选数组
      if (newVal > 0) this.$refs.multipleTable.clearSelection();
    },
    // 监听提示信息
    tipList: {
      handler(newVal) {
        // 存在打印语句时
        if (newVal.includes("print")) {
          // 获取文件路径
          this.fun_GetFileUrl();
        }
      },
      immediate: true // 立即执行
    },
    // 监听提示信息
    dialogTipList: {
      handler(newVal) {
        // 有值
        if (newVal.length > 0) {
          // 遍历数据
          newVal.map(e => {
            // 判断是否存在AdobeReader
            if (e.type === "AdobeReader") {
              // 获取文件路径
              this.fun_GetFileUrl();
            }
          });
          // 显示
          this.dialog = true;
        }
      },
      immediate: true // 立即执行
    }
  },
  // 自定义方法
  methods: {
    /**
     * @description 获取文件路径
     * @author shuhua
     */
    fun_GetFileUrl() {
      // 发起请求
      fun_GetAction("/clientFileInfo/getAutomaticallyUpdateFiles", {
        number: 2,
        appName: "AdobeReader11"
      }).then(res => {
        // 解构res.data
        const { result, data } = res.data;
        // 操作成功
        if (result) {
          // 文件路径
          this.fileUrl = data;
        }
      });
    },
    /**
     * 提示显示内容
     */
    fun_GetTip(i) {
      return `（${i + 1}）点击“打印”前须安装<a href="${
        this.fileUrl
      }">AdobeReader（点击下载）</a>等PDF软件，如未安装则不能在线打印！`;
    },
    /**
     * 打开弹窗
     */
    fun_GetUnpackDialog() {
      // 打开
      this.dialog = true;
    },
    /**
     * 关闭弹窗
     */
    fun_GetOffDialog() {
      // 关闭
      this.dialog = false;
    },
    /**
     * @description 下拉框change事件
     * @author 滕威
     */
    fun_SelectChange(value, field, options) {
      this.$emit("fun_GetSelectVal", value.code, field, options);
    },
    /**
     * @description 下拉框change事件
     * @author 滕威
     */
    fun_Clear(field, options) {
      this.$emit("fun_Clear", field, options);
    },
    /**
     * @description 查询表单查询方法
     * @author 滕威
     */
    fun_Search() {
      this.$emit("fun_Search");
    },
    /**
     * @description 查询表单重置方法
     * @author 滕威
     */
    fun_Reset() {
      this.$emit("fun_Reset");
    },
    /**
     * @description 点击单元格名称
     * @author 滕威
     */
    fun_LookDetails(val, name) {
      // 子传父
      this.$emit("fun_LookDetails", { val, name });
    },
    /**
     * @description 点击按钮
     * @param {e} 按钮名称
     * @author 滕威
     */
    fun_click(e) {
      this.$emit("fun_click", e);
    },
    /**
     * @description 查询旁边点击按钮
     * @param {e} 按钮名称
     * @author 滕威
     */
    fun_SearcClick(e) {
      this.$emit("fun_SearcClick", e);
    },
    /**
     * 改变每页条数执行的函数
     * @params val 每页条数
     * @author 滕威
     */

    fun_HandleSizeChange(val) {
      // 子组件向父组件传递方法，使用$emit("方法名", 需要传递的值)
      this.$emit("fun_LimitChange", val);
    },
    /**
     * 改变页码执行的函数
     * @params val 页码数
     * @author 滕威
     */

    fun_HandleCurrentChange(val) {
      // 子组件向父组件传递方法，使用$emit("方法名", 需要传递的值)
      this.$emit("fun_PageChange", val);
    }
  }
};
</script>
<style lang="scss" scoped>
// 修改查询表单按钮样式
.layout-list {
  position: relative;
  .poperTipBtn {
    color: #e57302;
    font-size: 16px;
    display: flex;
    align-items: center;
    i {
      color: #e57302;
      margin-right: 5px;
      font-size: 18px;
    }
  }
  .tipDialogBtn {
    background: #fff5ea;
    position: absolute;
    right: 0;
    cursor: pointer;
    border-radius: 2px;
    z-index: 999;
    border: 1px solid #f1d7ba;
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 7px;
    .text {
      position: relative;
      color: #e57302;
      writing-mode: vertical-rl;
    }
    i {
      color: #e57302;
      margin-bottom: 5px;
    }
  }
  .dialogTip.dialogHidden {
    height: 0;
    width: 0;
    opacity: 0;
    // overflow: hidden;
    pointer-events: none;
    .tipCentent {
      display: none;
    }
  }
  .dialogTip {
    position: fixed;
    transition: all 0.3s ease;
    right: 90px;
    width: 700px;
    height: auto;
    box-shadow: 0px 0px 15px 1px rgba(0, 0, 0, 0.2);
    writing-mode: horizontal-tb;
    z-index: 99999;
    .dialogHeader {
      display: flex;
      align-items: center;
      justify-content: space-between;
      padding: 16px 10px;
      background: #f6f9ff;
      border-bottom: 1px solid #e9e9e9;
      .t {
        padding-left: 10px;
        font-weight: bold;
        font-size: 18px;
        color: #333333;
      }
      .rIcon {
        i {
          color: #666666;
          font-size: 18px;
        }
      }
    }
    .tipCentent {
      padding: 30px 20px;
      background: linear-gradient(#f0f4ff, #f9fafe);
      .title {
        text-align: center;
        font-weight: bold;
        font-size: 18px;
        color: #e57302;
        margin-bottom: 30px;
        display: flex;
        align-items: center;
        justify-content: center;
        i {
          font-size: 22px;
          color: #e57302;
          margin-bottom: 0;
          margin-right: 10px;
        }
      }
      .ul {
        .li {
          line-height: 22px;
          /deep/.tit {
            color: rgba(51, 51, 51, 0.9);
            a {
              color: rgba(51, 51, 51, 0.9);
              font-weight: bold;
              text-decoration: underline;
            }
          }
        }
      }
    }
    .dialogBtn {
      text-align: center;
      padding: 20px;
      border-top: 1px solid #e9e9e9;
      background: #ffffff;
    }
  }
  .headerLabel {
    span {
      color: #0E70B5;
    }
  }
  .el-form {
    .el-row {
      .up {
        max-height: 50px !important;
        overflow: hidden;
      }
      .el-col {
        max-height: 1000px;
        transition: 0.7s;
        .unfold {
          display: inline-block;
          .el-form-item {
            margin-bottom: 0;
          }
        }
        .el-form-item {
          .el-input,
          .el-date-editor,
          .el-select {
            width: 270px;
          }
          /deep/.el-form-item__content {
            .comBtn {
              padding: 10px 12px;
              .el-icon-search {
                font-size: 16px;
              }
            }
            .resetBtn {
              padding: 10px 12px;
              .el-icon-refresh-right {
                font-size: 16px;
                color: #666666;
              }
              > span {
                font-size: 16px;
                color: rgba(0, 0, 0, 0.65);
              }
            }
          }
        }
      }
    }
    /deep/.searcBtn {
      .el-form-item__content {
        .el-button {
          padding: 10px 12px;
          i {
            color: #333333;
            font-size: 16px;
          }
          > span {
            font-size: 16px;
            color: rgba(0, 0, 0, 0.65);
          }
        }
      }
    }
    .el-button {
      padding: 8px 15px;
    }
  }
  .opTips {
    padding: 6px;
    box-sizing: border-box;
    margin-bottom: 10px;
    background-color: #F1F6F9;
    border: 1px solid #FEE5E2;
    display: flex;
    span {
      line-height: 24px;
    }
    :nth-child(1) {
      color: #ec2e2e;
    }
    :nth-child(2) {
      color: #666666;
    }
  }
  .tips {
    padding: 6px;
    box-sizing: border-box;
    margin: 10px 0;
    background-color: #f6f9ff;
    border: 1px solid #d9e3f8;
    border-radius: 4px 4px 4px 4px;
    display: flex;
    flex-direction: column;
    .icon {
      color: #ec2e2e;
      line-height: 24px;
      .el-icon-info {
        color: #ec2e2e;
        margin-right: 5px;
      }
    }
    .text {
      padding-left: 25px;
      .tit {
        font-size: 14px;
        color: #666666;
        line-height: 24px;
        background: none;
      }
    }
  }
}
</style>
